module.exports = __webpack_public_path__ + "img/W-S69.09d41595.jpg";